<template>
    <div class="record-fees loading-content-container">
        <div v-if="feesListLoading > 0" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-if="feesListLoading === 0" class="mb-4">
            <csp-desktop-info-card
                :cols="12"
                icon="inticon-users"
                title="Kostennote">
                <csp-record-detail-fee-create-modal
                    v-if="permissions.canCreateFee && createModalAvailable"
                    :form-context="creationFormContext"
                    :record-id="recordId"
                    @created="loadFees();resetCreateModal()"/>
                <csp-record-detail-fee-edit-modal
                    v-if="editModalFeeId"
                    :fee-id="editModalFeeId"
                    :form-context="editFormContext"
                    :is-modal-open="shouldShowFeeEditModal"
                    :record-id="recordId"
                    @close="resetEditModal"
                    @updated="loadFees"/>
                <csp-record-detail-fee-detail-modal
                    :fee-id="detailModalFeeId"
                    :is-modal-open="shouldShowFeeDetailModal"
                    :record-id="recordId"
                    @close="resetDetailModal"
                    @updated="loadFees"/>
                <div class="fee-list-table">
                    <csp-record-detail-fees-list
                        :fees="fees"
                        @fee-delete="deleteFee"
                        @fee-details="showFeeDetails"
                        @fee-edit="showFeeEdit"/>
                </div>

                <div v-if="fees.length" class="fee-legends collapse-body mt-5">
                    <div class="row">
                        <div class="legends col-md-4">
                            <div class="legend">
                                <div class="row">
                                    <div class="col-2 text-right">
                                        <span class="legend-symbol legend-adjustment">*</span>
                                    </div>
                                    <div class="col-10">
                                        <p>Betrag beinhaltet Teil- / Gutschrift</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <csp-record-detail-fees-summary :fee-summary="feeSums"/>
                        </div>
                    </div>
                </div>
            </csp-desktop-info-card>
        </b-row>
    </div>
</template>

<script>
    import '@desktop/scss/components/record/fees.scss';

    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FeeCreateModal from '@desktop/components/record/fee/RecordFeeCreateModal.vue';
    import FeeDetailModal from '@desktop/components/record/fee/RecordFeeDetailModal.vue';
    import FeeEditModal from '@desktop/components/record/fee/RecordFeeEditModal.vue';
    import FeeList from '@desktop/components/record/fee/RecordFeeList.vue';
    import FeeSummary from '@desktop/components/record/fee/RecordFeeSummary.vue';
    import Container from '@services/Container';
    import FormContext from '@desktop/components/FormContext';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'RecordFees',
        components: {
            'csp-record-detail-fees-list': FeeList,
            'csp-record-detail-fees-summary': FeeSummary,
            'csp-record-detail-fee-create-modal': FeeCreateModal,
            'csp-record-detail-fee-detail-modal': FeeDetailModal,
            'csp-record-detail-fee-edit-modal': FeeEditModal,
        },
        mixins: [FormDataMixin],
        data() {
            const recordId = parseInt(this.$route.params.recordId);
            return {
                recordId,
                feesListLoading: 0,
                fees: [],
                feeSums: [],
                permissions: null,
                createModalAvailable: true,
                creationFormContext: new FormContext({
                    name: 'fee-create',
                    objectId: this.recordId,
                    reloadFields: [],
                    handleEditModeByQuery: false,
                    isInEditMode: true,
                }),
                detailModalFeeId: null,
                shouldShowFeeDetailModal: false,
                editModalFeeId: null,
                shouldShowFeeEditModal: false,
                editFormContext: new FormContext({
                    name: 'fee-edit',
                    reloadFields: [],
                    handleEditModeByQuery: false,
                    isInEditMode: true,
                }),
            };
        },
        created() {
            this.loadFees();
        },
        methods: {
            loadFees() {
                this.feesListLoading++;
                return recordRepository.loadFees(this.recordId).then(
                    (success) => {
                        this.fees = success.data.attributes.fees.data;
                        this.feeSums = success.data.attributes.feeSums.data?.attributes;
                        this.permissions = success.data.meta.permissions;

                        this.feesListLoading--;
                    }
                );
            },
            resetCreateModal() {
                this.createModalAvailable = false;
                this.$nextTick(() => {
                    this.createModalAvailable = true;
                });
                this.creationFormContext = new FormContext({
                    name: 'fee-create',
                    objectId: this.recordId,
                    reloadFields: [],
                    handleEditModeByQuery: false,
                    isInEditMode: true,
                });
            },
            showFeeDetails(feeId) {
                this.detailModalFeeId = parseInt(feeId);
                this.shouldShowFeeDetailModal = true;
            },
            resetDetailModal() {
                this.detailModalFeeId = null;
                this.shouldShowFeeDetailModal = false;
            },
            showFeeEdit(feeId) {
                this.editModalFeeId = parseInt(feeId);
                this.shouldShowFeeEditModal = true;
            },
            resetEditModal() {
                this.editModalFeeId = null;
                this.shouldShowFeeEditModal = false;
                this.editFormContext = new FormContext({
                    name: 'fee-edit',
                    reloadFields: [],
                    handleEditModeByQuery: false,
                    isInEditMode: true,
                });
            },
            deleteFee(feeId) {
                if (!confirm('Möchten Sie diese Kostennote wirklich löschen?')) {
                    return;
                }
                this.feesListLoading++;
                recordRepository.deleteFee(this.recordId, feeId).then(() => {
                    this.loadFees();
                    this.feesListLoading--;
                });
            },
        },
    }
</script>
